<template>
  <div class="tab-content">
    <el-form :model="quoteForm" ref="quoteForm" label-position="top" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Name" prop="name" required>
            <el-input
              v-model="quoteForm.name"
              placeholder="Enter quote name"
              @input="updateForm"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Event Type" prop="event_type" required>
            <el-select 
              disabled
              v-model="quoteForm.event_type" 
              placeholder="Select event type" 
              style="width: 100%"
              @change="updateForm"
            >
              <el-option label="Corporate Event" value="corporate"></el-option>
              <el-option label="Wedding" value="wedding"></el-option>
              <el-option label="Social Event" value="social"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
         
          <el-form-item label="Venue" prop="venue_id" required>
            <el-select 
              v-model="quoteForm.venue_id" 
              placeholder="Select venue" 
              style="width: 100%"
              :disabled="isEditMode"
              @change="updateForm"
            >
              <el-option
                v-for="venue in availableVenues"
                :key="venue.id"
                :label="venue.name"
                :value="venue.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Event Date">
            <el-date-picker
              disabled
              v-model="quoteForm.event_date"
              type="date"
              placeholder="Select event date"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="updateForm"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Total Cost" prop="total_cost" required>
            <el-input
              v-model="quoteForm.total_cost"
              placeholder="12000"
              type="number"
              @input="updateForm"
            >
              <template slot="prepend">$</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Valid Till">
            <el-date-picker
              v-model="quoteForm.valid_till"
              type="date"
              placeholder="Select valid till date"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="updateForm"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Row,
  Col,
  DatePicker
} from "element-ui";

export default {
  name: "QuoteSummary",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Row.name]: Row,
    [Col.name]: Col,
    [DatePicker.name]: DatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    availableVenues: {
      type: Array,
      default: () => []
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quoteForm: { ...this.value },
      rules: {
        name: [
          { required: true, message: 'Please enter quote name', trigger: 'blur' }
        ],
        event_type: [
          { required: true, message: 'Please select event type', trigger: 'change' }
        ],
        venue_id: [
          { required: true, message: 'Please select a venue', trigger: 'change' }
        ],
        status: [
          { required: true, message: 'Please select status', trigger: 'change' }
        ],
        total_cost: [
          { required: true, message: 'Please enter total cost', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: 'Please enter a valid amount', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    value: {
      handler(newVal) {
        // Preserve venue_id if it exists in current form but not in new value
        // This prevents venue selection from being cleared by parent updates
        const preservedVenueId = this.quoteForm?.venue_id && !newVal?.venue_id 
          ? this.quoteForm.venue_id 
          : newVal?.venue_id;
        
        this.quoteForm = { 
          ...newVal,
          ...(preservedVenueId ? { venue_id: preservedVenueId } : {})
        };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    updateForm() {
      this.$emit('input', { ...this.quoteForm });
    },

    validate() {
      return new Promise((resolve) => {
        this.$refs.quoteForm.validate((valid) => {
          resolve(valid);
        });
      });
    },

    resetValidation() {
      if (this.$refs.quoteForm) {
        this.$refs.quoteForm.resetFields();
      }
    }
  }
};
</script>

<style scoped>
.tab-content {
  padding: 20px 0;
  min-height: 400px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input-group__prepend {
  background-color: #f5f7fa;
  color: #909399;
  border: 1px solid #dcdfe6;
}
</style>